export type ActivityType =
    | 'COMMUNITY_EVENT'
    | 'SERVICE_ORDER'
    | 'ACTION_ITEM'
    | 'SERVICE_REQUEST'
    | 'PROJECT'
    | 'DEADLINE'
    | 'MOVE_IN'
    | 'MOVE_OUT'
    | 'INSPECTION'
    | 'TOUR'

export interface DailyActivityItem {
    id: string
    date: string
    type: ActivityType
    title: string
    subtitle?: string
    time?: string
    sortTime: string
    count?: number
    color?: string
    status?: string
    description?: string
    location?: string
    /** Index into workorderClusters for cluster detail modal */
    clusterIndex?: number
    sourceData: unknown
}

export interface ActivityTypeMeta {
    type: ActivityType
    label: string
    color: string
}

export const ACTIVITY_TYPE_META: ActivityTypeMeta[] = [
    { type: 'COMMUNITY_EVENT', label: 'Events', color: '#008C85' },
    { type: 'SERVICE_ORDER', label: 'Service Orders', color: '#3b82f6' },
    { type: 'ACTION_ITEM', label: 'Action Items', color: '#8b5cf6' },
    { type: 'SERVICE_REQUEST', label: 'Service Requests', color: '#06b6d4' },
    { type: 'PROJECT', label: 'Projects', color: '#f59e0b' },
    { type: 'INSPECTION', label: 'Inspections', color: '#6366f1' },
    { type: 'TOUR', label: 'Tours', color: '#ec4899' },
    { type: 'DEADLINE', label: 'Deadlines', color: '#ef4444' },
    { type: 'MOVE_IN', label: 'Move Ins', color: '#10b981' },
    { type: 'MOVE_OUT', label: 'Move Outs', color: '#f97316' },
]

export const ACTIVITY_TYPE_LABEL: Record<
    ActivityType,
    string
> = ACTIVITY_TYPE_META.reduce((acc, meta) => {
    acc[meta.type] = meta.label
    return acc
}, {} as Record<ActivityType, string>)

export const ACTIVITY_TYPE_COLOR: Record<
    ActivityType,
    string
> = ACTIVITY_TYPE_META.reduce((acc, meta) => {
    acc[meta.type] = meta.color
    return acc
}, {} as Record<ActivityType, string>)

export interface DayGroup {
    label: string
    sortKey: string
    items: DailyActivityItem[]
}
